import {isEmpty} from 'lodash-es';
import type {ReactElement} from 'react';
import {useState} from 'react';

import {Button} from '@/components';
import type {AfriexRate, AfriexRatePromo, UserType} from '@/types';

import TierFormModal from './TierFormModal';

type TierUpdateButtonProps = {
  initialData?: AfriexRatePromo;
  rawAppRates?: AfriexRate[];
  target?: UserType;
  businessId?: string;
  businessName?: string;
  /** Test hook prefix; the open button renders it as `<dataCy>-button`. */
  dataCy?: string;
  /** Test hook prefix for the form modal (each field namespaces under it). */
  formDataCy?: string;
  /** Called after a successful create/update so the list can refresh in place. */
  onSuccess?: () => void | Promise<void>;
};

const TierUpdateButton = ({
  initialData,
  rawAppRates,
  target,
  businessId,
  businessName,
  dataCy,
  formDataCy,
  onSuccess,
}: TierUpdateButtonProps): ReactElement => {
  const [showFullScreen, setShowFullScreen] = useState(false);
  const updateLabel = isEmpty(initialData)
    ? 'Create Rate Tier +'
    : 'Update Tier';
  const toggleFullScreen = () => {
    setShowFullScreen(!showFullScreen);
  };

  return showFullScreen ? (
    <TierFormModal
      isOpen={showFullScreen}
      onClose={toggleFullScreen}
      initialData={initialData}
      rawAppRates={rawAppRates}
      target={target}
      businessId={businessId}
      businessName={businessName}
      formDataCy={formDataCy}
      onSuccess={onSuccess}
    />
  ) : (
    <Button
      dataCy={dataCy}
      variant="solid"
      colorScheme="cyan"
      onClick={toggleFullScreen}
    >
      {updateLabel}
    </Button>
  );
};

export default TierUpdateButton;
